<template>
	<v-hub />
</template>

<script setup>
import VHub from './v-hub.vue';
</script>
